import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        // ── ApplyStrat token-based variants ──
        primary:   "bg-brand text-white hover:bg-brand-hover hover:-translate-y-0.5 hover:shadow-[0_6px_20px_rgba(255,82,0,0.35)] active:scale-[0.98] active:translate-y-0 transition-all duration-300",
        secondary: "bg-surface-raised text-ink hover:bg-border transition-all",
        outline:   "border border-border text-ink hover:bg-surface-raised transition-all",
        ghost:     "text-ink hover:bg-surface-raised transition-all",
        link:      "text-brand underline-offset-4 hover:underline",
        // ── Kept for backwards-compat with shadcn internal usage ──
        default:     "bg-brand text-white hover:bg-brand-hover active:scale-[0.98] transition-all",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 transition-all",
      },
      size: {
        sm:      "h-8 px-4 text-sm rounded-md",
        default: "h-11 px-6 text-sm rounded-full",
        lg:      "h-13 px-8 text-base rounded-full",
        icon:    "h-9 w-9 rounded-md",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
